import client from './client';

export const seatsApi = {
  // ============================================================================
  // SEAT PURCHASES
  // ============================================================================

  /**
   * List current user's seat purchases
   */
  async getPurchases() {
    const { data } = await client.get('/api/seats/purchases');
    return data;
  },

  /**
   * Create checkout session for purchasing seats
   */
  async createCheckoutSession(quantity) {
    const { data } = await client.post('/api/seats/purchases', { quantity });
    return data;
  },

  /**
   * Get details of a specific purchase with allocations
   */
  async getPurchase(purchaseId) {
    const { data } = await client.get(`/api/seats/purchases/${purchaseId}`);
    return data;
  },

  /**
   * Update seat quantity
   */
  async updateQuantity(purchaseId, quantity) {
    const { data } = await client.patch(`/api/seats/purchases/${purchaseId}`, { quantity });
    return data;
  },

  /**
   * Cancel subscription (at period end)
   */
  async cancelPurchase(purchaseId) {
    const { data } = await client.delete(`/api/seats/purchases/${purchaseId}`);
    return data;
  },

  /**
   * Create Stripe billing portal session
   */
  async createPortalSession(purchaseId) {
    const { data } = await client.post(`/api/seats/purchases/${purchaseId}/portal`);
    return data;
  },

  // ============================================================================
  // SEAT ALLOCATIONS
  // ============================================================================

  /**
   * List allocations for a purchase
   */
  async getAllocations(purchaseId, status = null) {
    const params = status ? { status } : {};
    const { data } = await client.get(`/api/seats/purchases/${purchaseId}/allocations`, { params });
    return data;
  },

  /**
   * Allocate a seat to a user
   */
  async allocateSeat(purchaseId, { email, userId, note }) {
    const { data } = await client.post(`/api/seats/purchases/${purchaseId}/allocations`, {
      email,
      userId,
      note,
    });
    return data;
  },

  /**
   * Revoke an allocation
   */
  async revokeAllocation(purchaseId, allocationId) {
    const { data } = await client.delete(
      `/api/seats/purchases/${purchaseId}/allocations/${allocationId}`
    );
    return data;
  },

  // ============================================================================
  // USER'S OWN ALLOCATION
  // ============================================================================

  /**
   * Get current user's seat allocation (if any)
   */
  async getMyAllocation() {
    const { data } = await client.get('/api/seats/my-allocation');
    return data;
  },

  /**
   * Search users by email for seat allocation
   */
  async searchUsers(email) {
    const { data } = await client.get('/api/seats/users/search', { params: { email } });
    return data;
  },
};
